"use client";
import LocalStorage from "@workspace/casino_pages/legacyLayer/client/utils/storage/LocalStorage";
import SessionStorage from "@workspace/casino_pages/legacyLayer/client/utils/storage/SessionStorage";
import { getCookie } from "@workspace/cookies/browser";

const isNotificationClosed = (notification: WorkerNotification) => {
  const { id } = notification.data;
  if (!id) {
    return false;
  }
  const { dismissStrategy = { storage: "session" } } = notification;
  if (dismissStrategy.storage === "cookie") {
    return !!getCookie(id);
  }
  if (dismissStrategy.storage === "local") {
    return !!LocalStorage.getItem(id);
  }
  return !!SessionStorage.getItem(id);
};

export default isNotificationClosed;
